<template>
    <sonicu-button  bg-color="bg-white"
                    bg-color-hover="bg-red-600"
                    text-color="text-red-700"
                    text-color-hover="text-white"
                    border-color="border-red-200"
                    border-color-hover="border-red-400"
                    bg-color-active="bg-red-600"
                    border-color-active="border-red-600"
                    @click="$emit('click', $event)"
    >
        <slot></slot>
    </sonicu-button>
</template>

<script>

import SonicuButton from "@/components/elements/buttons/SonicuButton";

export default {
    name: "ButtonRedSecondary",
    mixins: [],
    emits: ['click'],
    components: {SonicuButton},
    props: {
        
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>